<template>
    <dialog-template headerTitle="退款"
        width="400px"
        v-if="rowData != null"
        v-bind="$attrs"
        v-on="$listeners">
        <div class="body-wrapper">
            <p>订单编号：{{ rowData.order_no }}</p>
            <p>退款金额：<span class="balance"> <span>￥</span>{{ fixNum(get(rowData, 'actual_payment')) }}</span></p>
            <p class="refund-text">{{ refundtext }}</p>
        </div>
        <div class="footer" slot="footer">
            <el-button type="danger"
                size="medium"
                :disabled="isRefunding"
                @click="confirm">
                {{ confirmText }}
            </el-button>
            <el-button type="default"
                size="medium"
                @click="$emit('update:visible', false)">取消</el-button>
        </div>
    </dialog-template>
</template>

<script>
import { openMessage } from '../../../utils/system'
import clone from 'lodash/cloneDeep'
import get from 'lodash/get'
import { fixNum } from '@/utils/index'

export default {
    data() {
        return {
            isRefunding: false
        }
    },
    computed: {
        confirmText() {
            if (this.isRefunding) {
                return '退款中...'
            } else {
                return '确认'
            }
        },

        refundtext() {
            if (Object.prototype.toString.call(this.rowData.payments) !== '[object Array]') {
                return ''
            }
            // const arr = ['未知类型', '现金', '微信', '支付宝', '余额']
            // return `${this.fixNum(this.get(this.rowData, 'subtotal') - this.get(this.rowData, 'remnant_neglected'))}元退回${this.get(this.rowData, 'payment_type.channel_type_text')}`
            return this.rowData.payments.reduce((next, prev) => {
                next.push(`${fixNum(prev.payment_amount)}元退回${prev.payment_type_text} `)
                return next
            }, []).join(' ')
        },

        get() {
            return get
        },

        fixNum() {
            return fixNum
        }
    },
    props: {
        rowData: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        confirm() {
            new Promise((resolve, reject) => {
                this.isRefunding = true
                this.$emit('confirm', resolve, reject)
            }).then(() => {
                this.$emit('update:visible', false)
                openMessage('success', `订单${ this.rowData.order_no }退款成功，${ this.fixNum(this.rowData.actual_payment) }元已通过原支付方式退回`)
            }, (e = {}) => openMessage('error', e.message || '退款失败'))
            .finally(() => setTimeout(() => this.isRefunding = false, 300))
        }
    }
}
</script>

<style lang="scss" scoped>
.body-wrapper {
    padding: 10px;
    border: 1px solid #ddd;

    p {
        color: #333333;

        &:first-child {
            height: 20px;
            line-height: 20px;
            font-size: 14px;
        }

        &:nth-child(2) {
            height: 22px;
            line-height: 22px;
            margin: 8px 0;

            .balance {
                font-size: 16px;
                color: #EE5928;

                span {
                    font-size: 14px;
                }
            }
        }

        &:nth-child(3) {
            font-size: 12px;
            color: #666666;
            text-align: center;
            line-height: 16px;
        }
    }

    .refund-text {
        display: inline-block;
        padding-left: 70px;
    }
}

.footer {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
